import { render, staticRenderFns } from "./ListadoLiquidaciones.vue?vue&type=template&id=018c716d"
import script from "./ListadoLiquidaciones.vue?vue&type=script&lang=js"
export * from "./ListadoLiquidaciones.vue?vue&type=script&lang=js"
import style0 from "./ListadoLiquidaciones.vue?vue&type=style&index=0&id=018c716d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VSimpleTable})
